// =============================================================================
// app/src/lib/desconto.ts — desconto em % e em R$, um espelhando o outro.
//
// Pedido do dono (12/08/2026): digitar 10% e ver o valor em reais no campo ao
// lado — e vice-versa —, com o total abatendo sozinho. O que VAI AO BANCO
// continua sendo o valor em R$ (registrar_venda não mudou): o percentual é
// conveniência de digitação, não dado novo — guardar os dois seria guardar
// derivado, e derivado diverge (regra 4 do CLAUDE.md, em miniatura).
//
// Arredondamento SEMPRE para 2 casas na conversão %→R$: é dinheiro. A volta
// R$→% também mostra 2 casas, mas é só exibição — quem manda é o R$.
// =============================================================================

/**
 * 10% de R$ 157,90 → R$ 15,79. Percentual fora de 0–100 devolve null (110% é
 * erro de digitação, não desconto); carrinho vazio devolve null porque não há
 * do que descontar.
 */
export function percentualParaValor(pct: number | null, bruto: number): number | null {
  if (pct === null || !Number.isFinite(pct) || pct < 0 || pct > 100) return null;
  if (!Number.isFinite(bruto) || bruto <= 0) return null;
  return Math.round(bruto * pct) / 100;
}

/**
 * R$ 15,79 sobre R$ 157,90 → 10%. Valor acima do bruto devolve null (o total
 * nunca fica negativo — a tela já trava isso — mas o espelho não deve fingir
 * que 120% é um percentual).
 */
export function valorParaPercentual(valor: number | null, bruto: number): number | null {
  if (valor === null || !Number.isFinite(valor) || valor < 0) return null;
  if (!Number.isFinite(bruto) || bruto <= 0) return null;
  if (valor > bruto) return null;
  return Math.round((valor / bruto) * 10000) / 100;
}

/**
 * Número → texto de campo, em pt-BR: 15.79 → "15,79", 10 → "10" (sem ",00" de
 * enfeite — campo espelhado cheio de zeros parece travado). Nulo → vazio.
 */
export function numeroParaTexto(n: number | null): string {
  if (n === null || !Number.isFinite(n)) return '';
  const fixo = n.toFixed(2).replace(/\.?0+$/, '');
  return fixo.replace('.', ',');
}
